import React, { useCallback, useRef, useState } from 'react';
import Webcam from 'react-webcam';
import PropTypes from 'prop-types';

/**
 * component return DLS Video component
 * @param {*} props
 */
const CameraVideo = ({ createFile }) => {
  const webcamRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const [capturing, setCapturing] = useState(false);
  const [recordedChunks, setRecordedChunks] = useState([]);

  const fieldId = 'video_cam_buttons';
  const fieldLabel = {
    // label: 'Temp',
    cssProperties: {
      style: 'btn btn-block margin-3-tb margin-auto-lr',
    },
  };

  const handleDataAvailable = useCallback(
    ({ data }) => {
      if (data.size > 0) {
        setRecordedChunks((prev) => [...prev, data]);
      }
    },
    [setRecordedChunks]
  );

  const handleStartCaptureClick = useCallback(() => {
    setCapturing(true);
    mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
      mimeType: 'video/webm',
    });
    mediaRecorderRef.current.addEventListener(
      'dataavailable',
      handleDataAvailable
    );
    mediaRecorderRef.current.start();
  }, [webcamRef, setCapturing, mediaRecorderRef, handleDataAvailable]);

  const handleStopCaptureClick = useCallback(() => {
    mediaRecorderRef.current.stop();
    setCapturing(false);
  }, [mediaRecorderRef, setCapturing]);

  const saveVideo = useCallback(() => {
    if (recordedChunks.length > 0) {
      const blob = new Blob(recordedChunks, {
        type: 'video/webm',
      });
      createFile(blob, 'video_content.webm');
    }
  }, [recordedChunks]);

  const videoConstraints = {
    width: 420,
    height: 420,
    facingMode: 'user',
  };

  return (
    <div className="Container">
      <Webcam
        height={400}
        width={400}
        audio={true}
        muted={true}
        mirrored={true}
        ref={webcamRef}
        videoConstraints={videoConstraints}
      />
      {capturing ? (
        <button
          type="submit"
          className={`${fieldLabel.cssProperties.style} ${fieldId}`}
          onClick={handleStopCaptureClick}
        >
          Stop
        </button>
      ) : (
        <button
          type="submit"
          className={`${fieldLabel.cssProperties.style} ${fieldId}`}
          onClick={handleStartCaptureClick}
        >
          Start
        </button>
      )}
      {recordedChunks.length > 0 && (
        <button
          type="submit"
          className={`${fieldLabel.cssProperties.style} ${fieldId}`}
          onClick={saveVideo}
        >
          Send
        </button>
      )}
    </div>
  );
};

CameraVideo.propTypes = {
  createFile: PropTypes.func,
};

export default CameraVideo;
